export interface AnswerPersonWithNameAndPosition
  extends PersonWithNameAndPosition {}

export interface PersonWithNameAndPosition {
  name: string;
  surname: string;
  position: string;
}

export const createEmptyPersonWithNameAndPosition =
  (): PersonWithNameAndPosition => {
    return {
      name: "",
      surname: "",
      position: "",
    };
  };
